import { render, staticRenderFns } from "./ChangeOma.vue?vue&type=template&id=2d78ec64"
import script from "./ChangeOma.vue?vue&type=script&lang=js"
export * from "./ChangeOma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports